import erp from "../erp"
import goodsList from "../items/goods_list"
import goodsStockList from "../items/goods_stock_list"
import purchaseList from "../items/purchase_list"
import stockJournal from "../items/stock_journal_list"

export default {
	path:'erp',
	name:'erp',
	component:erp,
	children:[
		{
			path:'goods/list',
			name:'goods-list',
			component:goodsList
		},
		{
			path:'goods/stock/list',
			name:'goods-stock-list',
			component:goodsStockList
		},
		{
			path:'purchase/list',
			name:'purchase-list',
			component:purchaseList
		},
		{
			path:'stock/journal/list',
			name:'stock-journal-list',
			component:stockJournal
		},
	]
}